module.exports = __webpack_public_path__ + "img/img23.2f9496a5.svg";